module.exports = __webpack_public_path__ + "img/menu_bottom_12.8484543a.svg";